import { Sun, Moon } from "@phosphor-icons/react";
import { useTheme } from "../context/ThemeContext";

/* Compact theme toggle. Two variants:
   - "icon" (default): square icon-only — fits navbars and mobile top bars.
   - "row":  full-width row with label — fits sidebar / profile menus.
*/
export default function ThemeToggle({ variant = "icon", testid = "theme-toggle" }) {
  const { theme, toggleTheme } = useTheme();
  const isDark = theme === "dark";
  const next = isDark ? "light" : "dark";
  const Icon = isDark ? Sun : Moon;
  const label = isDark ? "Switch to light mode" : "Switch to dark mode";

  if (variant === "row") {
    return (
      <button
        onClick={toggleTheme}
        className="btn-ghost w-full px-3 py-2 text-sm inline-flex items-center justify-center gap-2"
        title={label}
        aria-label={label}
        data-testid={testid}
      >
        <Icon size={16} weight="duotone" />
        {isDark ? "Light mode" : "Dark mode"}
      </button>
    );
  }

  return (
    <button
      onClick={toggleTheme}
      className="h-9 w-9 inline-flex items-center justify-center text-muted-foreground hover:text-foreground border hairline rounded-sm transition"
      title={label}
      aria-label={label}
      data-testid={testid}
      data-theme-next={next}
    >
      <Icon size={16} weight="duotone" />
    </button>
  );
}
